import { DS2 } from '../../theme/designTokens';

export function UnreadBadge({ count }: { count: number }) {
  return (
    <span
      style={{
        marginLeft:     5,
        display:        'inline-flex',
        alignItems:     'center',
        justifyContent: 'center',
        minWidth:       16,
        height:         16,
        padding:        '0 4px',
        borderRadius:   8,
        background:     '#E05252',
        color:          '#FFFFFF',
        fontFamily:     DS2.font.body,
        fontSize:       9.5,
        fontWeight:     700,
        verticalAlign:  'middle',
      }}
    >
      {count > 9 ? '9+' : count}
    </span>
  );
}
